import React from 'react'
import styles from './styles.module.css'
import Product from '@page-components/Order/Products/ProductsContent/Category/Product'
import hasWebpSupport from '@helpers/misc/hasWebpSupport'

const format = hasWebpSupport() ? 'webp' : 'jpeg'

export default function Products(props) {
  const {menuId, products, hideNotAvailableProducts} = props

  return (
    <div className={styles.container}>
      {products.map(product =>
        hideNotAvailableProducts && product.isOutOfStock ? null : (
          <div className="col-xs-6 col-sm-3 col-md-2 col-lg-2" key={product._id}>
            {/* @ts-expect-error ts-migrate(2322) FIXME: Type '{ product: any; productsLayout: string; menu... Remove this comment to see the full error message */}
            <Product product={product} productsLayout="compact" menuId={menuId} format={format} />
          </div>
        )
      )}
    </div>
  )
}
